import React from 'react'
import PropTypes from 'prop-types'

import { Avatar } from 'components'
import { Typography } from '@telavita-core/react-design-kit'

const MenuUserInfo = ({
  avatar,
  email,
  firstName,
}) => {
  return (
    <div className="MenuUserInfo">
      <div className="MenuUserInfo__avatar">
        <Avatar avatarSize='40px' imgAlt={firstName} imgUrl={avatar} />
      </div>

      <div>
        <Typography variant='content2' weight='bolder' customClassName='MenuUserInfo__name'>
          {firstName}
        </Typography>
        <Typography variant='content3' customClassName='MenuUserInfo__email'>
          {email}
        </Typography>
      </div>
    </div>
  )
}

MenuUserInfo.propTypes = {
  avatar: PropTypes.string,
  email: PropTypes.string,
  firstName: PropTypes.string,
}

export default MenuUserInfo